/* hc-chat-clearance.js (DEX-002, 2026-10-14; footer handling DEX-003, same day)
   Publishes --hc-chat-clear on <html>: the height of the PDP sticky buy bar while it is showing on phones, else 0px.
   hc-dex.css adds it to the Shopify chat bubble's bottom offset so the bubble sits above the bar.
   Also toggles html.hc-footer-in-view while the footer is on screen so the sticky bar slides away instead of covering the footer.
   Observers are attached only to our own theme elements (never to the chat widget). */
(function () {
  var root = document.documentElement;
  var mq = window.matchMedia('(max-width: 767px)');
  var bar = null;
  var last = '';
  var footerVisible = false;
  function set(v) {
    if (v !== last) { last = v; root.style.setProperty('--hc-chat-clear', v); }
  }
  function update() {
    if (!bar || !mq.matches) { set('0px'); return; }
    set(bar.closest('.hc__is-sticky-atc') && !footerVisible ? bar.offsetHeight + 'px' : '0px');
  }
  function init() {
    bar = document.querySelector('hc-sticky-buy-buttons');
    if (!bar) return;
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(bar);
    var item = bar.closest('.product-info__block-item');
    if (item) new MutationObserver(update).observe(item, { attributes: true, attributeFilter: ['class'] });
    var footer = document.querySelector('.shopify-section--footer');
    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        root.classList.toggle('hc-footer-in-view', footerVisible);
        update();
      }).observe(footer);
    }
    if (mq.addEventListener) mq.addEventListener('change', update);
    window.addEventListener('pageshow', update);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();